import { z } from 'zod';

export const ConnectorTypeSchema = z.enum(['terminal_block', 'header', 'harness', 'other']);

export const ConnectorSchema = z.object({
  id: z.string().min(1),
  project_id: z.string().min(1),
  label: z.string().min(1),
  type: ConnectorTypeSchema,
  hardware_id: z.string().nullable(),
  description: z.string().nullable(),
  archived_at_ms: z.number().int().nullable(),
  created_at_ms: z.number().int().nonnegative(),
  updated_at_ms: z.number().int().nonnegative(),
});

export const CreateConnectorSchema = ConnectorSchema.omit({
  id: true,
  created_at_ms: true,
  updated_at_ms: true,
});

export type ParsedConnectorType = z.infer<typeof ConnectorTypeSchema>;
export type ParsedConnector = z.infer<typeof ConnectorSchema>;
export type ParsedCreateConnector = z.infer<typeof CreateConnectorSchema>;
